import { ThemeOptions } from "@mui/material/styles/createTheme";

export const MuiChip = {
  styleOverrides: {
    root: ({ theme }: { theme: ThemeOptions }) => {
      return {
        fontSize: "0.9rem",
        borderColor: theme?.palette?.divider,
        boxShadow: "none",
      };
    },
    sizeLarge: {
      height: "40px",
      borderRadius: "40px",
    },
    labelLarge: {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
};
